module.exports = __webpack_public_path__ + "static/img/gh.5de17c83.png";